// ============================================================================
// Last Mile lane vocabulary — labels + how lanes are grouped into rows on the
// board. Split out so the page component and the mock data generator both
// read from one place (mirrors oms/logistics/components/board_meta.tsx).
// ============================================================================
import { CarOutlined, GlobalOutlined, ThunderboltFilled } from "@ant-design/icons";
import React from "react";
import { LastMileLaneKey } from "./types";

export const LANE_LABEL: Record<LastMileLaneKey, string> = {
  standard_blr: "Bengaluru",
  standard_hyd: "Hyderabad",
  express_blr: "Bengaluru",
  express_hyd: "Hyderabad",
  outstation_vendor: "Vendor Outstation",
  outstation_client: "Client Outstation",
  outstation_both: "Both Outstation",
};

// The three group rows the Last Mile section renders, top to bottom, and which
// lanes fall under each. Each row carries its own icon — lightning for Express,
// a truck for Standard, a globe for Outstation — so the rows scan at a glance.
export const LANE_GROUPS: {
  title: string;
  icon: React.ReactNode;
  help: string;
  lanes: LastMileLaneKey[];
}[] = [
  {
    title: "Express",
    icon: <ThunderboltFilled style={{ color: "#faad14" }} />,
    help: "Priority (express-mode) last-mile deliveries, split by the city desk that owns them.",
    lanes: ["express_blr", "express_hyd"],
  },
  {
    title: "Standard",
    icon: <CarOutlined style={{ color: "#1677ff" }} />,
    help: "Regular-priority last-mile deliveries, split by the city desk that owns them.",
    lanes: ["standard_blr", "standard_hyd"],
  },
  {
    title: "Outstation",
    icon: <GlobalOutlined style={{ color: "#722ed1" }} />,
    help: "Final-mile hop is outside our own fleet — split by who is doing it.",
    lanes: ["outstation_vendor", "outstation_client", "outstation_both"],
  },
];

export const LANE_ORDER: LastMileLaneKey[] = LANE_GROUPS.flatMap((g) => g.lanes);
